<template>
  <div
      :class="{ 'thumb': true,
                'selected': selected,
                'm-2': true, }"
      :style="{ 'width': width+'px'}"
      v-if="!deleted"
      @click="select(design.key)">
    <div class="delete" @click="$bvToast.show(deleteToastName)">
      <b-icon-x-circle-fill aria-hidden="true"></b-icon-x-circle-fill>
    </div>
    <span class="toast-holder">
      <b-toast :id="deleteToastName" title="Confirm Delete" static auto-hide-delay="12000">
        <p>Delete this design?</p>
        <b-button
            variant="danger"
            @click.stop="deleteDesign(design.key)"
            class="m-1">
          <b-icon-trash aria-hidden="true"></b-icon-trash>
          Delete
        </b-button>
        <b-button
            variant="secondary"
            @click="$bvToast.hide(deleteToastName)"
            class="m-1">
            Cancel
        </b-button>
      </b-toast>
    </span>
    <DesignView
        :design="design"
        :toolimages="design.toolimages"
        lazy
        ref="designview"
    ></DesignView>
    <div>{{ design.name }}</div>
  </div>
</template>

<script>
// NOTE: this shares a lot with ImageThumb
import { mapState } from 'vuex';

import { BIconXCircleFill, BIconTrash } from 'bootstrap-vue';
import axios from 'axios';

import DesignView from '@/components/DesignView.vue';

export default {
  name: 'DesignThumb',
  components: {
    DesignView,
    BIconXCircleFill,
    BIconTrash,
  },
  props: {
    design: Object,
    width: Number,
  },
  data() {
    return {
      deleted: false,
      deleteToastName: `delete-toast-${this.design.key}`,
    };
  },
  computed: {
    selected() {
      return this.design.key === this.designToSelect;
    },
    ...mapState(['config', 'designToSelect', 'savedDesigns', 'product']),
  },
  methods: {
    select(key) {
      // pick this design on click
      console.log('design select', key);
      this.$store.commit('setDesignToSelect', key);
    },
    deleteDesign(key) {
      console.log('delete', key, this.config.objDeleteURL + key);
      this.$bvToast.hide(this.deleteToastName);
      axios.post(this.config.objDeleteURL + key)
        .then((response) => {
          console.log('deleted', response);
          if (this.designToSelect === key) {
            this.$store.commit('clearDesignToSelect');
          }
          this.deleted = true;
          const newSavedDesigns = this.savedDesigns.filter((elt) => elt.key !== key);
          this.$store.commit('setSavedDesigns', newSavedDesigns);
        })
        .catch((error) => {
          console.log(error);
          let errmsg = 'An unknown error occurred.';
          if (error.request) {
            console.log(error.request);
            errmsg = `An error occurred: ${error.response.statusText} (${error.response.status})`;
          } else if (error.response) {
            console.log(error.response);
            errmsg = 'Could not contact the server.';
          } else {
            console.log(error.message);
            errmsg = `An unknown error occurred: ${error.message}`;
          }
          this.$bvToast.toast(
            errmsg,
            {
              title: 'Delete Error',
              toaster: 'b-toaster-top-center',
              autoHideDelay: 12000,
              variant: 'danger',
              solid: true,
            },
          );
        });
    },
  },
  mounted() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.thumb {
  display: inline-block;
  /* width: 150px;
  height: 150px; */
  box-sizing: content-box;
  border-width: medium;
  border-style: solid;
  border-color: #00000000;
  vertical-align: top;
}

.thumb.selected {
  background-color: orange;
}

.delete {
  display:block;
  position: relative;
  z-index: 10;
  height: 0;
  top: -4px;
  left: 2px;
  color: #AAAc;
  font-size: 1.4rem;
  width: 1.8rem;
  text-shadow: 1px 1px 2px red;
  cursor: pointer;
}

.toast-holder {
  display: block;
  position: fixed;
  z-index: 100;
}
</style>
